import script from "./SuggestInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuggestInput.vue?vue&type=script&lang=ts&setup=true"

import "./SuggestInput.vue?vue&type=style&index=0&id=12bd2d7a&lang=scss"

const __exports__ = script;

export default __exports__